import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { TextField, Grid } from "@material-ui/core";

import { Page, Tabla } from "components";
import serviciosTablero from "utils/serviciosTablero";
import { Autocomplete } from "@material-ui/lab";
import { Controller } from "react-hook-form";

const TablerosArchivados = ({
  setCargando,
  setMensaje,
  idjerarquia,
  usuario,
  permisos,
  ...props
}) => {
  const [data, setData] = useState([]);
  const cerrarMensaje = () => setMensaje({ open: false });

  const cargarInfo = () => {
    serviciosTablero.getTablerosArchivados(
      (status, mensaje, data) => {
        if (status < 0) {
          setMensaje({
            open: true,
            status: -1,
            value: "Error al obtener información.",
          });
          return;
        }

        setData(data || []);
      },
      setCargando,
      {}
    );
  };

  const DesarchivarTablero = (data) => {
    serviciosTablero.archivarTablero(
      (status, mensaje, data) => {
        setMensaje({ open: true, status: status, value: mensaje });
        if (status > 0) {
          setData(data);
          window.location.reload();
        }
      },
      setCargando,
      { idtablero: data?.idtablero, idestatus: 1 }
    );
  };

  const columnas = [
    { label: "Titulo", name: "titulo", filtrar: true },
    { label: "Solicitud asignada", name: "nsol", filtrar: true },
    { label: "Fecha creación", name: "fcrea", filtrar: true },
    { label: "Creado por", name: "ncrea", filtrar: true },
    { label: "Fecha archivado", name: "fmodifica", filtrar: true },
    { label: "Archivado por", name: "nmodifica", filtrar: true },
  ];

  const opcionesFila = [
    {
      label: "Desarchivar",
      onClick: DesarchivarTablero,
      enabled: [2, 3].includes(usuario[0]?.idrol),
    },
  ];

  useEffect(() => {
    cargarInfo();
  }, []);

  return (
    <Grid container spacing={1}>
      <Grid xs={12}>
        <Tabla
          columns={columnas}
          rows={data}
          usarEstilosTablero={true}
          accionesFila={opcionesFila}
        />
      </Grid>
    </Grid>
  );
};

export default TablerosArchivados;
